export default __webpack_public_path__ + "static/media/location.a1594754.svg";